import { Module } from '@nestjs/common';
import { BiMessageService } from '@schemax-whatsapp/shared-services/whatsapp-api';
import { HrmsDbConnectionService } from '../db-connections/hrms-db-connection.service';
import { ExcelImportService } from './excel-import.service';
import { WhatsappBroadCastController } from './whatsapp-broad-cast.controller';
import { WhatsappBroadCastService } from './whatsapp-broad-cast.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ExcelImport } from '../entity/excel-import.entity';
import { ExcelImportAdapter } from './adapter/excel-import.adapter';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      ExcelImport
    ])
  ],
  controllers: [WhatsappBroadCastController],
  providers: [WhatsappBroadCastService, HrmsDbConnectionService, BiMessageService, ExcelImportService, ExcelImportAdapter,ApplicationExceptionHandler]
})
export class WhatsappBroadCastModule {}

